import gql from "graphql-tag";
import graphqlClient from "../../../apollo";

class ForecastProvider {
  ApplyForecast(appJson) {
    return graphqlClient.mutate({
      mutation: gql`
        mutation forecastTool($appJson: String!) {
          forecastTool(appJson: $appJson) {
            data
          }
        }
      `,
      variables: {
        appJson,
      },
    });
  }

  ApplyExportExcel(headers, data, headers2, data2) {
    return graphqlClient.mutate({
      mutation: gql`
        mutation exportExcel(
          $headers: [String]!
          $data: String!
          $headers2: [String]!
          $data2: String!
        ) {
          exportExcel(
            headers: $headers
            headers2: $headers2
            data: $data
            data2: $data2
          ) {
            url
          }
        }
      `,
      variables: {
        headers,
        data,
        headers2,
        data2,
      },
    });
  }

  gerDataFeForecast(country) {
    return graphqlClient.query({
      query: gql`
        query teForecast($country: String!) {
          teForecast(filter: $country) {
            data
          }
        }
      `,
      variables: {
        country,
      },
    });
  }

  getDataLastSemester(country) {
    return graphqlClient.query({
      query: gql`
        query lastSemester($country: String!) {
          lastSemester(filter: $country) {
            data
          }
        }
      `,
      variables: {
        country,
      },
    });
  }

  getConsensusReport(country) {
    return graphqlClient.query({
      query: gql`
        query consensusResults($country: String!) {
          consensusResults(filter: $country) {
            data
          }
        }
      `,
      variables: {
        country,
      },
    });
  }

  getConsensusReportEndogenize(country) {
    return graphqlClient.query({
      query: gql`
        query consensusResultsEndogenize($country: String!) {
          consensusResultsEndogenize(filter: $country) {
            data
          }
        }
      `,
      variables: {
        country,
      },
    });
  }
}

export default new ForecastProvider();
